<template>
  <div id="StoryWrapper">
    <div id="Container" ref="cars" :style="style">
      <template v-for="generation in generations">
        <Car
          v-for="car in generation.models"
          :key="car.model"
          :car="car"
          :year="generation.start"
          @update-style="updateStyle"
          @car-change="onActiveCarChange"
        />
      </template>
    </div>
    <Nav
      id="Nav"
      :cars="cars"
      :generations="generations"
      :active="active"
      @car-change="onActiveCarChange"
    />
  </div>
</template>

<script>
import Car from '@/components/Car.vue';
import Nav from '@/components/Nav.vue';
import generations from '@/data/porsche.json';

export default {
  name: 'Story',

  components: {
    Car,
    Nav
  },

  data: () => ({
    generations,
    active: 0,
    showInfo: false,
    style: {}
  }),

  computed: {
    cars() {
      return this.generations.map(x => x.models).flat();
    }
  },

  watch: {
    active(val) {
      if (val >= 0) {
        this.updateStyle();
      }
    }
  },

  mounted() {
    setTimeout(() => {
      this.updateStyle();
    }, 50);
  },

  created() {
    window.addEventListener('resize', this.updateStyle);
  },

  destroyed() {
    window.removeEventListener('resize', this.updateStyle);
  },

  methods: {
    onActiveCarChange(name) {
      this.active = this.cars.findIndex(x => x.name === name);
    },

    updateStyle() {
      this.style = {};
      const wrapper = this.$refs.cars;

      if (wrapper) {
        const childs = wrapper.childNodes;
        const childsArray = [...childs];

        const x = childsArray
          .slice(0, this.active + 1)
          .map(item => item.clientWidth)
          .reduce((a, v, idx) => a - (idx === 0 ? v / 2 : v), 0 + window.innerWidth / 2);

        const y = 0;

        this.style.transform = `translate3d(${x}px, ${y}, -0)`;
      }
    }
  }
};
</script>

<style lang="scss">
#StoryWrapper {
  overflow: hidden;
  height: 100%;

  #Container {
    display: flex;
    height: calc(100% - 80px);
    transition: 500ms transform ease-in-out;
  }

  #Nav {
    height: 80px;
    min-width: 100%;
    background-color: rgb(158, 158, 158);
  }
}
</style>
